
import { useContext } from 'react';
import Spinner from '@ihs-widget/components/common/Spinner';
import SingleLineStatistic from '@ihs-widget/components/StatsConsole/Widgets/StatsWidget/parts/SingleLineStatistic';
import DoubleLineStatistic from '@ihs-widget/components/StatsConsole/Widgets/StatsWidget/parts/DoubleLineStatistic';
import { StateContext } from "../../../../state/stateContext"; // TODO: import from @ihs-widget/state/stateContext, not works why?
import { ActiveFilterName, T } from "@ihs-widget/utils/enums";
import TripleCircleStatistic from './parts/TripleCircleStatistic';
import CardsRow from '@ihs-widget/components/StatsConsole/Widgets/StatsWidget/parts/CardsRow';
import GoalRow from '@ihs-widget/components/StatsConsole/Widgets/StatsWidget/parts/GoalRow/GoalRow';
import GoalRowImageBg from '@ihs-widget/components/StatsConsole/Widgets/StatsWidget/parts/GoalRowImageBg/GoalRowImageBg';
import FiltersStats from './parts/FiltersStats';
import RefreshIconAndText from '@ihs-widget/components/common/RefreshIconAndText';
import { useLoadingWithRefresh } from '@ihs-widget/utils/hooks/useLoadingWithRefresh';
import { useVersion } from '@ihs-widget/utils/hooks/useVersion';
import type { MatchClockData } from '@ihs-widget/components/StatsConsole/Layout/StandardAndExpandedStatsConsole/StandardAndExpandedStatsConsole';

interface IStatsWidgetProps {
    eventId: string | null;
    statsData: any;
    statsTabData: any;
    overviewData: any;
    isMVP?: boolean;
    matchTime?: MatchClockData;
}

const StatsWidget = ({ statsData, statsTabData, isMVP = true }: IStatsWidgetProps) => {
    const { isV2 } = useVersion();


    const ctx = useContext(StateContext);
    const { stContext } = ctx || {};
    const { statsTabActiveFilterName } = stContext || {};



    return (
        <div className='w-full'>
            <FiltersStats statsTabData={statsTabData} />
            <div className='px-[16px] w-full mb-[16px]'>
                {statsTabData?.[statsTabActiveFilterName ?? ActiveFilterName.FULL_MATCH]?.statistics.map((stat: any, index: number) => {
                    const isFirstItem = index === 0;
                    const isLastItem = index === statsTabData?.full_match?.statistics.length - 1;
                    const mt = isFirstItem ? "mt-0" : "mt-[24px]";
                    const mb = isLastItem ? "mb-[16px]" : "mb-0";

                    if (isMVP) {
                        switch (true) {
                            case stat.type === 'triple-circle':
                                return null;

                            case stat.type === 'double-line' && stat.label_1 === 'InHouseStats.Passes':
                                return <SingleLineStatistic
                                    key={`single-line${stat.label_1}-${stat.label_2}-${index}`}
                                    label={stat.label_1}
                                    home={stat.home_1}
                                    away={stat.away_1}
                                    isPercentage={stat.is_percentage_1}
                                    mt={mt}
                                    mb={mb}
                                />;

                            case stat.type === 'double-line' && stat.label_2 === 'InHouseStats.Passes':
                                return <SingleLineStatistic
                                    key={`single-line${stat.label_1}-${stat.label_2}-${index}`}
                                    label={stat.label_2}
                                    home={stat.home_2}
                                    away={stat.away_2}
                                    isPercentage={stat.is_percentage_2}
                                    mt={mt}
                                    mb={mb}
                                />;

                            default:
                                break;
                        }
                    }

                    if (stat.type === 'single-line') {
                        return <SingleLineStatistic
                            key={`single-line${stat.label}-${index}`}
                            label={stat.label}
                            home={stat.home}
                            away={stat.away}
                            isPercentage={stat.is_percentage}
                            mt={mt}
                            mb={mb}
                        />
                    } else if (stat.type === 'double-line') {
                        return <DoubleLineStatistic
                            key={`double-line${stat.label_1}-${stat.label_2}-${index}`}
                            label_1={stat.label_1} home_1={stat.home_1} away_1={stat.away_1} isPercentage_1={stat.is_percentage_1}
                            label_2={stat.label_2} home_2={stat.home_2} away_2={stat.away_2} isPercentage_2={stat.is_percentage_2}
                            mt={mt}
                            mb={mb}
                        />
                    } else if (stat.type === 'triple-circle') {
                        return <TripleCircleStatistic
                            key={`triple-circle${stat.label_1}-${stat.label_2}-${stat.label_3}-${index}`}
                            label_1={stat.label_1} home_1={stat.home_1} away_1={stat.away_1} isPercentage_1={stat.is_percentage_1}
                            label_2={stat.label_2} home_2={stat.home_2} away_2={stat.away_2} isPercentage_2={stat.is_percentage_2}
                            label_3={stat.label_3} home_3={stat.home_3} away_3={stat.away_3} isPercentage_3={stat.is_percentage_3}
                            mt={mt}
                            mb={mb}
                        />
                    } else if (stat.type === 'cards-row') {
                        return <CardsRow
                            key={`cards-row-${index}`}
                            homeCorners={stat.homeCorners} homeYellowCards={stat.homeYellowCards} homeRedCards={stat.homeRedCards}
                            awayCorners={stat.awayCorners} awayYellowCards={stat.awayYellowCards} awayRedCards={stat.awayRedCards}
                        />
                    } else if (stat.type === 'goal-row') {
                        const GoalComponent = isV2 ? GoalRowImageBg : GoalRow;
                        return <GoalComponent
                            key={`goal-row-${index}`}
                            homeShotsOnTarget={stat.homeShotsOnTarget} homeShotsOffTarget={stat.homeShotsOffTarget}
                            awayShotsOnTarget={stat.awayShotsOnTarget} awayShotsOffTarget={stat.awayShotsOffTarget}
                        />
                    }
                    return null;
                })}
            </div>
        </div>
    )
}

export default StatsWidget;
